// Add your custom JS here.
$ = jQuery;

document.addEventListener("DOMContentLoaded", function () {
    runFrontpageCarousel();
    preparePartners();
    prepareProjects();
    fixAccessibilityOfEmCalendar();
    setTrainings();
    backToTop();
    setTimeout(function() {
        $('.ditty-playPause').attr('aria-label','Zatrzymaj / wznów przewijanie paska');
    }, 1000);

});

function runFrontpageCarousel() {
    const firstCarouselItem = document.querySelector('#carousel--frontpage .carousel-item:first-of-type');
    if (firstCarouselItem) {
        firstCarouselItem.classList.add('active');
        const carouselFrontpageNews = document.querySelector('#carousel--frontpage');
        const carouselFpNews = new understrap.Carousel(carouselFrontpageNews, {
            interval: 6000,
            wrap: true,
            keyboard: true,
            ride: true
        });

        const carouselBtn = document.querySelector('#carousel__btn');

        carouselBtn.addEventListener('click', function () {
            const btnText = document.querySelector('.carousel__autoplay .autoplay-text');
            const carouselAutoplay = document.querySelector('.carousel__autoplay');

            if (carouselAutoplay.classList.contains('stopped')) {
                carouselFpNews.cycle();
                btnText.innerText = 'WSTRZYMAJ';
            } else {
                carouselFpNews.pause();
                btnText.innerText = 'WZNÓW';
            }

            carouselAutoplay.classList.toggle('stopped');
            carouselAutoplay.querySelector('.play').classList.toggle('d-none');
            carouselAutoplay.querySelector('.pause').classList.toggle('d-none');

        });
    }
}

function preparePartners() {
    const partners = document.querySelector('.partners');
    const partnersBtn = partners.querySelector('.partners__btn');
    partnersBtn.addEventListener('click', function () {
        const btnText = partners.querySelector('.partners__autoplay .autoplay-text');
        const $fooPartners = $('#foogallery-gallery-5055'); //owl require jquery :/
        const fooPartnersAutoplay = partners.querySelector('.partners__autoplay');
        if (fooPartnersAutoplay.classList.contains('stopped')) {
            $fooPartners.trigger('play.owl.autoplay');
            btnText.innerText = 'WSTRZYMAJ';
            $fooPartners.next();
        } else {
            $fooPartners.trigger('stop.owl.autoplay');
            btnText.innerText = 'WZNÓW';
        }
        fooPartnersAutoplay.classList.toggle('stopped');
        fooPartnersAutoplay.querySelector('.play').classList.toggle('d-none');
        fooPartnersAutoplay.querySelector('.pause').classList.toggle('d-none');
    });
}
function prepareProjects() {
    const projects = document.querySelector('.projects');
    const projectsBtn = projects.querySelector('.partners__btn');
    projectsBtn.addEventListener('click', function () {
        const btnText = partners.querySelector('.partners__autoplay .autoplay-text');
        const $fooProjects = $('#foogallery-gallery-19362'); //owl require jquery :/
        const fooProjectsAutoplay = partners.querySelector('.partners__autoplay');
        if (fooProjectsAutoplay.classList.contains('stopped')) {
            $fooProjects .trigger('play.owl.autoplay');
            btnText.innerText = 'WSTRZYMAJ';
            $fooProjects .next();
        } else {
            $fooProjects .trigger('stop.owl.autoplay');
            btnText.innerText = 'WZNÓW';
        }
        fooProjects.Autoplay.classList.toggle('stopped');
        fooProjects.Autoplay.querySelector('.play').classList.toggle('d-none');
        fooProjects.Autoplay.querySelector('.pause').classList.toggle('d-none');
    });
}
$('.carousel-inner').each(function () {

    if ($(this).children('div').length === 1) $(this).siblings('.carousel-control-next, .carousel-control-prev, .carousel-indicators').hide();

});

$('.navbar-toggler-sites').click(function() {
    $(this).find('.dashicons').toggleClass('rotated');
});
$('.navbar-toggler-main').click(function() {
    if($(this).attr('aria-expanded') == 'true'){
        $(this).find('.navbar-toggler-text').text('Zwiń menu');
    } else {
        $(this).find('.navbar-toggler-text').text('Rozwiń menu');
    }

    $(this).find('.dashicons').toggleClass('d-none');
    $(this).find('.navbar-toggler-icon').toggleClass('d-none');
});

/*
$(document).click(function(e) {
    if (!$(e.target).is('#collapseSearch > *')) {
        $('#collapseSearch').collapse('hide');
    }
});
*/
function fixAccessibilityOfEmCalendar(){ //events manager calendar widget fix
    setTimeout( function(){
        $('#monthInput').unbind( "click", "focus" );}, 1000);
}

function setTrainings() {
    var trainingsTable = $('#trainings-content1 table');
    trainingsTable.attr('style', '').addClass('table');
    trainingsTable.find('*').attr('style', '');
    trainingsTable.find('a').append("&nbsp;<span class='fa fa-external-link' aria-hidden='true'></span>");
    $('#trainings-content1').find('h3').eq(0).hide();
    $('#trainings-content1').find('h4').eq(0).hide();
    $('#wiecej_szkolen').hide();
    $('#mniej_szkolen').hide();


    var moreSzkolen = $("#wiecejszkolen table tr");
    trainingsTable.first().append(moreSzkolen);

    var hideAllTr = $('#trainings-content1 table tr');
    hideAllTr.css('display','none');
    hideAllTr.slice(0,6).attr('style','');

    $( "#trainings-content1" ).on( "click", ".show-more_trainings", function() {
        hideAllTr.slice(0,100).attr('style','');
        $(this).text("Pokaż mniej szkoleń");
        $(this).addClass("show-less_trainings");
        $(this).removeClass('show-more_trainings');
    });

    $( "#trainings-content1" ).on( "click", ".show-less_trainings", function() {
        hideAllTr.css('display','none');
        hideAllTr.slice(0,6).attr('style','');

        $(this).removeClass("show-less_trainings");
        $(this).addClass('show-more_trainings');
        $(this).text("Pokaż więcej szkoleń");
    });
}

function backToTop() {
    let toToBtn = $('#totop');
    $(window).scroll(function () {
        if ($(this).scrollTop() > 400) {
            toToBtn.fadeIn();
        } else {
            toToBtn.fadeOut();
        }
    });
    toToBtn.click(function () {
        $('body,html').animate({scrollTop: $('body').offset().top}, 800);
        let body = $('body');
        body.attr('tabindex', '-1').focus();
        body.attr('tabindex', '');
        return false;
    });
}

function ChangeViewOnCalendarToMonth() {
    $('.wpfc-calendar-wrapper .wpfc-calendar').fullCalendar('changeView', 'month');
    $(".fc-month-button").addClass("fc-state-active");
    setMobileCalendar();

    $(window).resize(function () {
        setMobileCalendar();
    });
    function setMobileCalendar() {
        if ($(window).innerWidth() <= 767.98) {
            // const eventCalendar = $('.wpfc-calendar-wrapper .wpfc-calendar');

            $('.wpfc-calendar-wrapper .wpfc-calendar').fullCalendar('changeView', 'basic');

            $(".fc-basicDay-button").addClass("fc-state-active");
            $('.fc-right .fc-button-group').hide();
        } else {
            $('.fc-right .fc-button-group').show();
        }
    }
}
$( document ).on( "ajaxComplete", function() {
    ChangeViewOnCalendarToMonth();
    setTimeout(() => {
        $('.fc-title').each(function() {
            // get element text
            var text = $(this).text();
            // modify text
            text = text.replace('&#8222;','').replace('&#8221;','');
            // update element text
            $(this).text(text);
        });
    }, 1000);
} );


